module.exports = __webpack_public_path__ + "static/Anna-Lena_Sauer_at_Adagio.51992fb0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/blog/art-in-neighborhoods/Anna-Lena_Sauer_at_Adagio.jpg
// module id = 470
// module chunks = 107818501498521